<template>
    <div>
        <loading :active.sync="loadingContent" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Tukar Komisi</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Form Transfer -->
            <div class="section full mt-2">
                <ul class="listview image-listview inset">
                    <li>
                        <div class="item pt-2 pb-2 pl-3 pr-3">
                            <div class="in">
                                <div>Komisi saat ini</div>
                                <span class="text-primary">Rp {{ customer.komisi | rupiah }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="section full mt-2">
                <ul class="listview image-listview-product inset">
                    <li v-for="(item, index) in nominal" :key="index">
                        <a class="item pl-3 pr-3" @click="confirm(item)">
                            <div class="in">
                                <div style="width: 90%;">
                                    <div>Denom Saldo</div>
                                    <h4>Rp {{ item | rupiah }}</h4>
                                </div>
                                <div class="spinner-border spinner-border-sm text-primary" v-if="loading.select_nominal && data.nominal == item"></div>
                                <span class="text-muted" v-else>
                                    <div class="chip chip-primary ml-05 mb-05">
                                        <span class="chip-label">Rp {{ item | rupiah }}</span>
                                    </div>
                                </span>
                                
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- * Form Transfer -->
        </div>

        <action-sheet ref="confirm" :title="'Konfirmasi Penarikan'" :inset="true">
            <p>Anda akan melakukan penarikan Komisi sebesar <b>Rp {{data.nominal | rupiah}}</b> dengan Saldo Akun sebesar <b>Rp {{data.nominal | rupiah}}</b>?</p>
            <div class="form-group boxed" v-if="customer.pin_trx == 'ENABLED'">
                <label class="label text-center">Masukkan PIN</label>
                <input type="number" pattern="[0-9]*" inputmode="numeric" class="form-control form-control-lg text-center p-0 input-password" style="letter-spacing: 0.7em" maxlength="6" v-model="data.pin" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
            </div>
            
            <div class="form-group basic">
                <ButtonLoader :loading="loading.button" :styled="'btn btn-primary btn-block btn-lg'" @click.native="submit()">Ya, Tarik</ButtonLoader>
            </div>
        </action-sheet>

        <action-sheet ref="status" :title="'Penarikan Komisi'" :inset="true"> 
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Berhasil</h3>
                <p>Penarikan Komisi Anda berhasil</p>
            </div>
            <div class="form-group basic">
                <button class="btn btn-primary btn-block btn-lg" @click="action_sheet_status('hide')">Tutup</button>
            </div>
        </action-sheet>
    </div>
</template>
<script>
import $axios from './../api.js'
import { mapState, mapActions } from 'vuex'
export default {
    data() {
        return {
            loadingContent: false,
            loading : {
                button: false
            },
            nominal: ['500','1000','5000','10000','20000','50000','100000','250000','500000','1000000'],
            data: {
                nominal: '',
                password: ''
            },
        }
    },
    created(){
        this.loadingContent = true
        setTimeout(() => this.loadingContent = false, 500)
    },
    computed: {
        ...mapState(['customer','toast'])
    },
    methods:{
        ...mapActions(['getCustomer']),
        clear_data(){
            this.$store.commit('RESET_TOAST')
            this.data = {
                nominal: '',
                pin: ''
            }
        },
        confirm(nominal){
            this.data.pin = ''
            this.$store.commit('SET_TOAST', {show:false})
            this.data.nominal = nominal.replace(/[^,\d]/g, '');
            if(this.customer.komisi >= this.data.nominal){
                this.action_sheet_confirm('show')
            }else{
                this.$store.commit('SET_TOAST', {show:true,message:'Komisi Anda tidak cukup untuk melakukan penarikan',tipe:'default'})
            }
            
        },
        action_sheet_confirm(value){
            let element = this.$refs.confirm.$el
            window.$(element).modal(value)
        },
        action_sheet_status(value){
            let element = this.$refs.status.$el
            window.$(element).modal(value)
        },
        submit(){
            this.loading.button = true
            $axios.post('/withdrawal', this.data)
            .then(() => {
                this.loading.button = false
                this.clear_data()
                this.getCustomer()
                this.action_sheet_confirm('hide')
                this.action_sheet_status('show')
            }).catch(e => {
                this.loading.button = false
                this.action_sheet_confirm('hide')
                this.$store.commit('SET_TOAST', {show:true,message:e.response.data.message,tipe:'default'})
            })
        },
    },
    destroyed() {
        this.$store.commit('RESET_TOAST')
    }
}
</script>